import { render, staticRenderFns } from "./ImportsServer.vue?vue&type=template&id=e2b3ed1a"
import script from "./ImportsServer.vue?vue&type=script&lang=js"
export * from "./ImportsServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2b3ed1a')) {
      api.createRecord('e2b3ed1a', component.options)
    } else {
      api.reload('e2b3ed1a', component.options)
    }
    module.hot.accept("./ImportsServer.vue?vue&type=template&id=e2b3ed1a", function () {
      api.rerender('e2b3ed1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/parameters/ImportsServer.vue"
export default component.exports